import React from 'react';
import PropTypes from 'prop-types';
import { DynamicField } from '@totalsoft/rocket-ui';
import { addPropertyPrefix } from 'utils/propertyChangeAdapters';

export const BrowserFiltersComponent = ({ filter, validationInfo, onPropertyChange, loadOptions, idx }) => (
  <DynamicField
    id={filter.name}
    error={validationInfo && validationInfo.value ? true : false}
    controlType={filter.filterType.dynamicInputControlType}
    label={filter.filterCaption}
    onChange={addPropertyPrefix(idx, onPropertyChange)('value')}
    value={filter.value || ''}
    required={!filter.allowNull}
    helperText={validationInfo && validationInfo.value}
    loadOptions={loadOptions}
  />
);

BrowserFiltersComponent.propTypes = {
  onPropertyChange: PropTypes.func.isRequired,
  validationInfo: PropTypes.object,
  filter: PropTypes.object.isRequired,
  idx: PropTypes.number.isRequired,
  loadOptions: PropTypes.func
};

export default BrowserFiltersComponent;
